import React, { Fragment } from 'react';
import { Intro, DragAndDrop } from 'dea-core';
import img from '../../assets/images/U1-T1-12.svg';

const PRESCRIPTION = 'Over-prescription of Opioids';
const HEROIN = 'Increased Heroin Production';
const FENTANYL = 'Increased Illicit Fentanyl Production';

const dragOptions = [PRESCRIPTION, HEROIN, FENTANYL];

const dropZoneMessage = 'Drag elements here';

const MEDIUM_TERM = '2005 ⏤ Present Day';
const SHORT_TERM = '2012 ⏤ Present Day';
const IN_THE_PAST = '1991 ⏤ 2011';

const dropZones = [IN_THE_PAST, MEDIUM_TERM, SHORT_TERM];

const data = {
  horizontal: true,
  dragOptions,
  dropZones,
  dropZoneMessage,
  question:
    'Place each of the following major contributors to the opioid epidemic into the correct timeline bucket.'
};

const correctInput = {
  [IN_THE_PAST]: [PRESCRIPTION],
  [MEDIUM_TERM]: [HEROIN],
  [SHORT_TERM]: [FENTANYL]
};

const feedback = {
  // TODO do not let this feedback make it into the final version
  success: {
    title: 'Correct!',
    body: ''
  },
  error: {
    title: 'Not quite!',
    body: 'While there is overlap, there is also a distinct progression.'
  },
  retry: {
    title: 'Oops! Try again!',
    body: ''
  }
};

export default {
  title: 'Question 2',
  path: '/challenge/question-2',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="Select elements to create matched pairs."
        lead=""
        img={img}
      />

      <DragAndDrop
        data={data}
        feedback={feedback}
        correctInput={correctInput}
        score={20}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/evaluate/Question2.js